import { StripeDictionary } from "./stripe_types";

export const esStripeDict: StripeDictionary = {
    'pricing-table-id': 'prctbl_1NudpCIM79T2sGy3UsKAcb6W',
    'publishable-key': 'pk_live_51NqU7BIM79T2sGy3O0VvS1yKpTSiEDZZmKNQ63BwTZIJwIfSsqAs4P71nhUQXbCkHeTM2ry0oKEImE35aV0FnCTR0095lDwVNr'
};
